import { render } from "./Logo.vue?vue&type=template&id=62cb2131"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\portfolio\\bhavindabhi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__